var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 41,
    viewBox: "0 0 28 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1135_116391)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2612 11.5045L25.2727 1.27002L8.72971 1.61941C8.72971 1.61941 -0.287553 19.5836 0.00706538 19.5481C0.301665 19.5125 8.75175 20.3843 8.75175 20.3843L1.52634 40.9607L28 12.516L18.2612 11.5045Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5264 11.4635L18.2834 11.3654L25.0237 0.960938L8.49528 1.71913C8.49528 1.71913 -0.047029 19.9004 0.246548 19.8576C0.383403 19.8376 2.29704 19.9709 4.30119 20.119C5.51732 19.7499 6.73946 19.3169 7.95898 18.8174C12.5797 16.9251 16.5277 14.3467 19.5264 11.4635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0896 7.1114C11.2309 7.74716 9.47209 7.91617 8.84401 6.89265C8.21489 5.89022 8.95438 4.07893 10.8132 3.44335C12.6651 2.79142 14.8421 3.61235 15.4634 4.61947C16.0994 5.63816 14.9416 6.45969 13.0896 7.1114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5947 12.018C7.84742 12.5903 7.06698 12.4063 6.75425 11.4754C6.44287 10.5483 6.71742 9.226 7.46465 8.65371C8.20957 8.07801 9.13335 8.47289 9.44371 9.40036C9.75744 10.3311 9.33954 11.4423 8.5947 12.018Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1135_116391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 40,
    fill: "white",
    transform: "translate(0 0.960938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.740c83546b6ecdafeee0.svg";
export { ForwardRef as ReactComponent };